import React, { useState } from 'react'
import toast from 'react-hot-toast'
import LoadingSpinner from '../ui/LoadingSpinner'
import { apiClient } from '../../lib/api'

interface GoogleLoginButtonProps {
  mode: 'login' | 'register'
  onSuccess?: () => void
  className?: string
}

const GoogleLoginButton: React.FC<GoogleLoginButtonProps> = ({
  mode,
  onSuccess,
  className = ''
}) => {
  const [isLoading, setIsLoading] = useState(false)

  const handleGoogleAuth = () => {
    setIsLoading(true)

    try {
      // For OAuth, we need to do a direct browser redirect, not an AJAX request
      const searchParams = new URLSearchParams({
        action: mode,
        // CRITICAL FIX: Redirect to OAuth callback page, NOT dashboard
        // The callback page will store the JWT token and THEN redirect to dashboard
        redirect: window.location.origin + '/oauth/callback'
      })

      // Direct browser redirect to the OAuth authorization endpoint
      const authUrl = `https://admin.reddminer.com/wp-json/redd-miner-leads/v1/oauth/authorize/google?${searchParams}`

      // This will cause the backend to redirect to Google's OAuth page
      window.location.href = authUrl
    } catch (error) {
      console.error('Google OAuth error:', error)
      toast.error(error instanceof Error ? error.message : 'Failed to start Google login')
      setIsLoading(false)
    }
  }

  return (
    <button
      type="button"
      onClick={handleGoogleAuth}
      disabled={isLoading}
      className={`
        flex w-full justify-center items-center space-x-3 px-4 py-2.5
        border border-gray-300 rounded-lg shadow-sm
        bg-white hover:bg-gray-50
        focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500
        disabled:opacity-50 disabled:cursor-not-allowed
        transition-colors duration-200
        ${className}
      `}
    >
      {isLoading ? (
        <>
          <LoadingSpinner size="sm" />
          <span className="text-sm font-medium text-gray-700">
            Connecting to Google...
          </span>
        </>
      ) : (
        <>
          {/* Google Icon */}
          <svg className="w-5 h-5" viewBox="0 0 24 24">
            <path
              fill="#4285F4"
              d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
            />
            <path
              fill="#34A853"
              d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
            />
            <path
              fill="#FBBC05"
              d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
            />
            <path
              fill="#EA4335"
              d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
            />
          </svg>
          <span className="text-sm font-medium text-gray-700">
            Continue with Google
          </span>
        </>
      )}
    </button>
  )
}

export default GoogleLoginButton